module.exports = __webpack_public_path__ + "img/51626507_L.27baa6d3.png";